import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import MyProfilePage from './pages/MyProfilePage';
import TeamPage from './pages/TeamPage';
import AdminPage from './pages/AdminPage';
import './styles.css';

function Topbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  function handleLogout() { logout(); navigate('/login'); }

  return (
    <div className="topbar">
      <span className="topbar-brand">Insights Discovery®</span>
      <nav className="topbar-nav">
        <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>Mein Profil</NavLink>
        <NavLink to="/team" className={({ isActive }) => isActive ? 'active' : ''}>Team</NavLink>
        {user?.role === 'admin' && <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>Admin</NavLink>}
      </nav>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span className="topbar-user">{user?.name}</span>
        <button className="topbar-nav" onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px 12px', borderRadius: 6, color: 'rgba(255,255,255,0.55)', fontSize: '0.82rem', transition: 'all 0.15s' }}
          onMouseEnter={e => e.target.style.color = '#fff'} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}>
          Abmelden
        </button>
      </div>
    </div>
  );
}

function ProtectedLayout() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <>
      <Topbar />
      <Routes>
        <Route path="/profile" element={<MyProfilePage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/admin" element={user.role === 'admin' ? <AdminPage /> : <Navigate to="/profile" />} />
        <Route path="*" element={<Navigate to="/profile" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<ProtectedLayout />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
